import React from 'react';
import {AppBar, Tabs, Tab, Typography, Box, useMediaQuery, Drawer, IconButton, Container} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import { useLocation } from 'react-router-dom';

import logo from "../../images/logo.jpeg"
import {useTheme} from "@mui/material/styles";

const getTabIndex = (pathname) => {
    const tabMap = {
        '/': 0,
        '/projects': 1,
        '/blog': 2,
        '/about': 3,
    };
    // Check if path starts with /blog/ for blog articles
    if (pathname.startsWith('/blog/')) return 2;
    return tabMap[pathname] || 0;
};

const Navigation = () => {
    const location = useLocation();
    const [value, setValue] = React.useState(getTabIndex(location.pathname));
    const [drawerOpen, setDrawerOpen] = React.useState(false);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    React.useEffect(() => {
        setValue(getTabIndex(location.pathname));
    }, [location.pathname]);

    const handleChange = (event, newValue) => {
        setValue(newValue);
        if (isMobile) setDrawerOpen(false);
    };

    const handleDrawerToggle = () => {
        setDrawerOpen(!drawerOpen);
    };

    const tabs = (
        <Tabs
            value={value}
            onChange={handleChange}
            textColor="primary"
            indicatorColor="primary"
            orientation={isMobile ? "vertical" : "horizontal"}
            sx={{
                '& .MuiTab-root': {
                    minHeight: isMobile ? 56 : 64,
                    fontSize: isMobile ? '1rem' : '0.9375rem',
                }
            }}
        >
            <Tab label="Home" href="/" />
            <Tab label="Projects" href="/projects" />
            {/*<Tab label="Blog" href="/blog" />*/}
            <Tab label="About" href="/about" />
        </Tabs>
    );

    return (
        <>
            <AppBar
                position="fixed"
                elevation={0}
                sx={{
                    backgroundColor: 'rgba(255, 255, 255, 0.85)',
                    backdropFilter: 'blur(20px)',
                    WebkitBackdropFilter: 'blur(20px)',
                    borderBottom: '1px solid rgba(148, 163, 184, 0.1)',
                    color: 'text.primary',
                    boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.05)',
                }}
            >
                <Container maxWidth="xl">
                    <Box sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        height: 64,
                        px: { xs: 1, sm: 2 }
                    }}>
                        {/* Logo */}
                        <Box sx={{
                            display: 'flex',
                            alignItems: 'center',
                            minWidth: { xs: 'auto', md: 200 }
                        }}>
                            <img
                                src={logo}
                                alt="Paul-Louis"
                                style={{
                                    borderRadius: '50%',
                                    height: 48,
                                    width: 48,
                                    objectFit: 'cover',
                                    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
                                    transition: 'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                    cursor: 'pointer',
                                }}
                                onMouseEnter={(e) => e.target.style.transform = 'scale(1.05)'}
                                onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
                                onClick={() => window.location.href = '/'}
                            />
                        </Box>

                        {/* Desktop Navigation */}
                        {!isMobile && (
                            <Box sx={{ flexGrow: 1, display: 'flex', justifyContent: 'center' }}>
                                {tabs}
                            </Box>
                        )}

                        {/* Mobile Menu Button */}
                        {isMobile && (
                            <IconButton
                                color="primary"
                                onClick={handleDrawerToggle}
                                sx={{
                                    '&:hover': {
                                        backgroundColor: 'rgba(37, 99, 235, 0.08)',
                                    }
                                }}
                                aria-label="menu"
                            >
                                <MenuIcon />
                            </IconButton>
                        )}

                        {/* Spacer for layout balance on desktop */}
                        {!isMobile && <Box sx={{ minWidth: 200 }} />}
                    </Box>
                </Container>
            </AppBar>

            {/* Mobile Drawer */}
            <Drawer
                anchor="right"
                open={drawerOpen}
                onClose={handleDrawerToggle}
                PaperProps={{
                    sx: {
                        width: 280,
                        backgroundColor: 'rgba(255, 255, 255, 0.95)',
                        backdropFilter: 'blur(20px)',
                        WebkitBackdropFilter: 'blur(20px)',
                    }
                }}
            >
                <Box sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    p: 2,
                    borderBottom: '1px solid rgba(148, 163, 184, 0.1)'
                }}>
                    <Typography variant="h6" color="primary" fontWeight={700}>
                        Menu
                    </Typography>
                    <IconButton onClick={handleDrawerToggle} color="primary">
                        <CloseIcon />
                    </IconButton>
                </Box>
                <Box sx={{ mt: 2 }}>
                    {tabs}
                </Box>
            </Drawer>

            {/* Spacer to prevent content from going under fixed AppBar */}
            <Box sx={{ height: 64 }} />
        </>
    );
};

export default Navigation;